import { Download } from "lucide-react";
import { useSettings } from "@/context/AppContext";

export function brochureHref(settings) {
  const b = settings?.brochure;
  if (!b?.enabled || !b?.url) return null;
  return `${process.env.REACT_APP_BACKEND_URL}${b.url}?download=1`;
}

export default function BrochureButton({ variant = "light", className = "" }) {
  const { settings } = useSettings();
  const href = brochureHref(settings);
  if (!href) return null;
  const title = settings.brochure.title || "Product Catalogue";
  const styles = variant === "dark"
    ? "border-gold/50 text-gold-light hover:bg-gold hover:text-forest"
    : "border-forest/25 text-forest hover:border-gold hover:text-gold-dark";
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="brochure-download-button"
      className={`group inline-flex items-center gap-2.5 border px-6 py-3 text-[11px] font-semibold uppercase tracking-[0.16em] transition-colors duration-300 ${styles} ${className}`}
    >
      <Download className="h-4 w-4 transition-transform duration-300 group-hover:translate-y-0.5" />
      Download {title}
      <span className="font-mono text-[9px] tracking-[0.1em] opacity-60">PDF</span>
    </a>
  );
}
